module.exports = __webpack_public_path__ + "img/float-btn@2x.897be973.png";